import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  notification: {
    display: 'flex',
    alignItems: 'center',
    padding: '14px',

    '&:not(:last-child)': {
      borderBottom: '1px solid transparent',
    },

    '@media screen and (min-width: 1441px)': {
      padding: '16px',
    },
  },

  photo: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',

    '@media screen and (min-width: 1441px)': {
      width: '72px',
      height: '72px',
    },
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    margin: '0 12px',
    flex: 1,

    '& > div': {
      height: '14px',
    },

    '& .desc': {
      width: '70%',
    },

    '@media screen and (min-width: 1441px)': {
      margin: '0 16px',
    },
  },

  status: {
    width: '14px',
    height: '14px',
    borderRadius: '50%',
    alignSelf: 'start',
    margin: '0 6px',

    '@media screen and (min-width: 1441px)': {
      width: '16px',
      height: '16px',
    },
  },
}));

export default useStyles;
